export default __webpack_public_path__ + "static/torii-5-2ffc0134b82bd63c1bcb42965f23cd7d.jpg";